import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setLayoutGridState } from '@/store/slices/layout-grid';
import { selectLayoutDirection, selectPanelOpen } from '@/store/slices/layout-grid/selectors';

import { clearSnapshot, getRules, getSnapshot, isInRegion, setSnapshot } from './panel-revert-tracker';

const usePanelRevertTracker = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const panelOpen = useAppSelector(selectPanelOpen);
  const direction = useAppSelector(selectLayoutDirection);

  const panelOpenRef = useRef(panelOpen);
  panelOpenRef.current = panelOpen;
  const directionRef = useRef(direction);
  directionRef.current = direction;
  const prevPathnameRef = useRef<string | null>(null);

  useLayoutEffect(() => {
    const prev = prevPathnameRef.current;
    const next = pathname;

    getRules().forEach((matcher) => {
      const wasIn = prev ? isInRegion(prev, matcher) : false;
      const isIn = isInRegion(next, matcher);

      if (!wasIn && isIn) {
        setSnapshot(matcher, panelOpenRef.current);
      } else if (wasIn && !isIn) {
        const snapshot = getSnapshot(matcher);
        if (snapshot !== undefined) {
          dispatch(
            setLayoutGridState({
              direction: directionRef.current,
              panelOpen: snapshot,
              oppositePanelOpen: 'store-value',
              footerOpen: 'store-value',
              pillarOpen: 'store-value',
              headerOpen: 'store-value',
            })
          );
          clearSnapshot(matcher);
        }
      }
    });

    prevPathnameRef.current = next;
  }, [pathname, dispatch]);
};

export default usePanelRevertTracker;
